import { DonorTraitTypes } from '@/app/components/Filter/Filters.types'
import { CatalogType } from '@prisma/client'

export const MIN_OOCYTES_FOR_ORDER = 6
export const MIN_VIALS_FOR_ORDER = 1

export const ActiveFilters = {
  [CatalogType.OOCYTE]: {
    [DonorTraitTypes.race]: true,
    [DonorTraitTypes.bloodType]: true,
    [DonorTraitTypes.bmi]: true,
    [DonorTraitTypes.bodyBuild]: true,
    [DonorTraitTypes.eyeType]: true,
    [DonorTraitTypes.hairTexture]: true,
    [DonorTraitTypes.hairType]: true,
    [DonorTraitTypes.height]: true,
    [DonorTraitTypes.weight]: true,
    [DonorTraitTypes.language]: true,
    [DonorTraitTypes.availabilityStatus]: true,
    [DonorTraitTypes.ethnicity]: true,
    [DonorTraitTypes.familyLimits]: false,
    [DonorTraitTypes.canadaProgram]: true,
    [DonorTraitTypes.available]: true,
    [DonorTraitTypes.availableUsa]: true,
    [DonorTraitTypes.availableAustralia]: true,
    [DonorTraitTypes.counselling]: true,
    [DonorTraitTypes.oocytesAvailable]: true,
    [DonorTraitTypes.oocytesProgram]: true,
    [DonorTraitTypes.vialsProgram]: false,
    [DonorTraitTypes.ownChildren]: true,
    [DonorTraitTypes.quarantine]: true,
    [DonorTraitTypes.quarantineStatus]: true,
    [DonorTraitTypes.vaccinationCovid19]: true,
    [DonorTraitTypes.nose]: false,
    [DonorTraitTypes.forehead]: false,
    [DonorTraitTypes.faceShape]: false,
    [DonorTraitTypes.lipsShape]: false,
    [DonorTraitTypes.horoscope]: false
  },
  [CatalogType.SPERM]: {
    [DonorTraitTypes.race]: true,
    [DonorTraitTypes.bloodType]: true,
    [DonorTraitTypes.bmi]: true,
    [DonorTraitTypes.bodyBuild]: true,
    [DonorTraitTypes.eyeType]: true,
    [DonorTraitTypes.hairTexture]: true,
    [DonorTraitTypes.hairType]: true,
    [DonorTraitTypes.height]: true,
    [DonorTraitTypes.weight]: true,
    [DonorTraitTypes.language]: true,
    [DonorTraitTypes.nose]: true,
    [DonorTraitTypes.forehead]: true,
    [DonorTraitTypes.faceShape]: true,
    [DonorTraitTypes.lipsShape]: true,
    [DonorTraitTypes.horoscope]: true,
    [DonorTraitTypes.availabilityStatus]: true,
    [DonorTraitTypes.ethnicity]: true,
    [DonorTraitTypes.familyLimits]: true,
    [DonorTraitTypes.canadaProgram]: false,
    [DonorTraitTypes.available]: false,
    [DonorTraitTypes.availableUsa]: false,
    [DonorTraitTypes.availableAustralia]: false,
    [DonorTraitTypes.counselling]: false,
    [DonorTraitTypes.oocytesAvailable]: false,
    [DonorTraitTypes.oocytesProgram]: false,
    [DonorTraitTypes.vialsProgram]: false,
    [DonorTraitTypes.ownChildren]: false,
    [DonorTraitTypes.quarantine]: false,
    [DonorTraitTypes.quarantineStatus]: false,
    [DonorTraitTypes.vaccinationCovid19]: false
  },
  [CatalogType.EMBRYO]: {
    [DonorTraitTypes.race]: false,
    [DonorTraitTypes.bloodType]: false,
    [DonorTraitTypes.bmi]: false,
    [DonorTraitTypes.bodyBuild]: false,
    [DonorTraitTypes.eyeType]: false,
    [DonorTraitTypes.hairTexture]: false,
    [DonorTraitTypes.hairType]: false,
    [DonorTraitTypes.height]: false,
    [DonorTraitTypes.weight]: false,
    [DonorTraitTypes.language]: false,
    [DonorTraitTypes.nose]: false,
    [DonorTraitTypes.forehead]: false,
    [DonorTraitTypes.faceShape]: false,
    [DonorTraitTypes.lipsShape]: false,
    [DonorTraitTypes.horoscope]: false,
    [DonorTraitTypes.availabilityStatus]: false,
    [DonorTraitTypes.ethnicity]: false,
    [DonorTraitTypes.familyLimits]: false,
    [DonorTraitTypes.canadaProgram]: false,
    [DonorTraitTypes.available]: false,
    [DonorTraitTypes.availableUsa]: false,
    [DonorTraitTypes.availableAustralia]: false,
    [DonorTraitTypes.counselling]: false,
    [DonorTraitTypes.oocytesAvailable]: false,
    [DonorTraitTypes.oocytesProgram]: false,
    [DonorTraitTypes.vialsProgram]: false,
    [DonorTraitTypes.ownChildren]: false,
    [DonorTraitTypes.quarantine]: false,
    [DonorTraitTypes.quarantineStatus]: false,
    [DonorTraitTypes.vaccinationCovid19]: false
  },
  [CatalogType.IFG]: {
    [DonorTraitTypes.race]: true,
    [DonorTraitTypes.bloodType]: true,
    [DonorTraitTypes.bmi]: true,
    [DonorTraitTypes.bodyBuild]: true,
    [DonorTraitTypes.eyeType]: true,
    [DonorTraitTypes.hairTexture]: true,
    [DonorTraitTypes.hairType]: true,
    [DonorTraitTypes.height]: true,
    [DonorTraitTypes.weight]: true,
    [DonorTraitTypes.language]: true,
    [DonorTraitTypes.availabilityStatus]: true,
    [DonorTraitTypes.ethnicity]: true,
    [DonorTraitTypes.familyLimits]: false,
    [DonorTraitTypes.canadaProgram]: false,
    [DonorTraitTypes.available]: false,
    [DonorTraitTypes.availableUsa]: false,
    [DonorTraitTypes.availableAustralia]: false,
    [DonorTraitTypes.counselling]: true,
    [DonorTraitTypes.oocytesAvailable]: true,
    [DonorTraitTypes.oocytesProgram]: true,
    [DonorTraitTypes.vialsProgram]: false,
    [DonorTraitTypes.ownChildren]: true,
    [DonorTraitTypes.quarantine]: true,
    [DonorTraitTypes.quarantineStatus]: true,
    [DonorTraitTypes.vaccinationCovid19]: true,
    [DonorTraitTypes.nose]: false,
    [DonorTraitTypes.forehead]: false,
    [DonorTraitTypes.faceShape]: false,
    [DonorTraitTypes.lipsShape]: false,
    [DonorTraitTypes.horoscope]: false
  }
}
